/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { ImportResults } from './ImportResults';
import {
  ImportResultsFromJSON,
  ImportResultsFromJSONTyped,
  ImportResultsToJSON,
} from './ImportResults';

/**
 *
 * @export
 * @interface Csv
 */
export interface Csv {
  /**
   *
   * @type {string}
   * @memberof Csv
   */
  authorId?: string;
  /**
   *
   * @type {string}
   * @memberof Csv
   */
  authorKey?: string;
  /**
   *
   * @type {Array<any>}
   * @memberof Csv
   */
  columns?: Array<any>;
  /**
   *
   * @type {number}
   * @memberof Csv
   */
  companyId: number;
  /**
   *
   * @type {string}
   * @memberof Csv
   */
  csvId?: string;
  /**
   * A map of csv column name to Lead.custom[x]
   * @type {{ [key: string]: string; }}
   * @memberof Csv
   */
  customMapping?: { [key: string]: string };
  /**
   *
   * @type {number}
   * @memberof Csv
   */
  dateCreated?: number;
  /**
   *
   * @type {string}
   * @memberof Csv
   */
  dateCreatedIso?: string;
  /**
   *
   * @type {number}
   * @memberof Csv
   */
  dateModified?: number;
  /**
   *
   * @type {string}
   * @memberof Csv
   */
  dateModifiedIso?: string;
  /**
   *
   * @type {string}
   * @memberof Csv
   */
  downloadUrl?: string;
  /**
   *
   * @type {string}
   * @memberof Csv
   */
  filename?: string;
  /**
   *
   * @type {string | null}
   * @memberof Csv
   */
  gcsFilename?: string | null;
  /**
   *
   * @type {string}
   * @memberof Csv
   */
  id: string;
  /**
   *
   * @type {ImportResults}
   * @memberof Csv
   */
  importResults?: ImportResults;
  /**
   *
   * @type {string}
   * @memberof Csv
   */
  key: string;
  /**
   *
   * @type {Array<any>}
   * @memberof Csv
   */
  labels?: Array<any>;
  /**
   * A map of csv column name to Lead attribute name
   * @type {{ [key: string]: string; }}
   * @memberof Csv
   */
  leadMapping?: { [key: string]: string };
  /**
   *
   * @type {string}
   * @memberof Csv
   */
  name?: string;
  /**
   *
   * @type {number | null}
   * @memberof Csv
   */
  numRows?: number | null;
  /**
   *
   * @type {string | null}
   * @memberof Csv
   */
  sortName?: string | null;
  /**
   *
   * @type {string}
   * @memberof Csv
   */
  state?: CsvStateEnum;
  /**
   * The strategy to use when de-duping a csv at import time
   * @type {string}
   * @memberof Csv
   */
  strategy?: CsvStrategyEnum;
  /**
   *
   * @type {Array<any>}
   * @memberof Csv
   */
  tags?: Array<any>;
}

/**
 * @export
 */
export const CsvLeadMappingEnum = {
  DoNotImport: 'do_not_import',
  FirstName: 'first_name',
  LastName: 'last_name',
  JobTitle: 'job_title',
  Industry: 'industry',
  Role: 'role',
  Department: 'department',
  ExternalId: 'external_id',
  Timezone: 'timezone',
  Lang: 'lang',
  PrimaryPhone: 'primary_phone',
  SecondaryPhone: 'secondary_phone',
  PrimaryEmail: 'primary_email',
  SecondaryEmail: 'secondary_email',
  AddressName: 'address_name',
  AddressLine1: 'address_line1',
  AddressLine2: 'address_line2',
  City: 'city',
  Region: 'region',
  PostalCode: 'postal_code',
  Country: 'country',
  CompanyName: 'company_name',
  CompanyPhone: 'company_phone',
  CompanyAddressLine1: 'company_address_line1',
  CompanyAddressLine2: 'company_address_line2',
  CompanyCity: 'company_city',
  CompanyRegion: 'company_region',
  CompanyPostalCode: 'company_postal_code',
  CompanyCountry: 'company_country',
  CompanySicCode: 'company_sic_code',
  CompanyNaicsCode: 'company_naics_code',
  CompanyBlacklisted: 'company_blacklisted',
  CompanyAnnualRevenue: 'company_annual_revenue',
  CompanyCurrency: 'company_currency',
  CompanyNumEmployees: 'company_num_employees',
} as const;
export type CsvLeadMappingEnum =
  (typeof CsvLeadMappingEnum)[keyof typeof CsvLeadMappingEnum];

/**
 * @export
 */
export const CsvStateEnum = {
  Pending: 'pending',
  Launching: 'launching',
  Scheduled: 'scheduled',
  Active: 'active',
  Paused: 'paused',
  Complete: 'complete',
  Error: 'error',
  Deleted: 'deleted',
} as const;
export type CsvStateEnum = (typeof CsvStateEnum)[keyof typeof CsvStateEnum];

/**
 * @export
 */
export const CsvStrategyEnum = {
  Skip: 'skip',
  Merge: 'merge',
} as const;
export type CsvStrategyEnum =
  (typeof CsvStrategyEnum)[keyof typeof CsvStrategyEnum];

/**
 * Check if a given object implements the Csv interface.
 */
export function instanceOfCsv(value: object): value is Csv {
  if (!('companyId' in value) || value['companyId'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('key' in value) || value['key'] === undefined) return false;
  return true;
}

export function CsvFromJSON(json: any): Csv {
  return CsvFromJSONTyped(json, false);
}

export function CsvFromJSONTyped(json: any, ignoreDiscriminator: boolean): Csv {
  if (json == null) {
    return json;
  }
  return {
    authorId: json['author_id'] == null ? undefined : json['author_id'],
    authorKey: json['author_key'] == null ? undefined : json['author_key'],
    columns: json['columns'] == null ? undefined : json['columns'],
    companyId: json['company_id'],
    csvId: json['csv_id'] == null ? undefined : json['csv_id'],
    customMapping:
      json['custom_mapping'] == null ? undefined : json['custom_mapping'],
    dateCreated:
      json['date_created'] == null ? undefined : json['date_created'],
    dateCreatedIso:
      json['date_created_iso'] == null ? undefined : json['date_created_iso'],
    dateModified:
      json['date_modified'] == null ? undefined : json['date_modified'],
    dateModifiedIso:
      json['date_modified_iso'] == null ? undefined : json['date_modified_iso'],
    downloadUrl:
      json['download_url'] == null ? undefined : json['download_url'],
    filename: json['filename'] == null ? undefined : json['filename'],
    gcsFilename:
      json['gcs_filename'] == null ? undefined : json['gcs_filename'],
    id: json['id'],
    importResults:
      json['import_results'] == null
        ? undefined
        : ImportResultsFromJSON(json['import_results']),
    key: json['key'],
    labels: json['labels'] == null ? undefined : json['labels'],
    leadMapping:
      json['lead_mapping'] == null ? undefined : json['lead_mapping'],
    name: json['name'] == null ? undefined : json['name'],
    numRows: json['num_rows'] == null ? undefined : json['num_rows'],
    sortName: json['sort_name'] == null ? undefined : json['sort_name'],
    state: json['state'] == null ? undefined : json['state'],
    strategy: json['strategy'] == null ? undefined : json['strategy'],
    tags: json['tags'] == null ? undefined : json['tags'],
  };
}

export function CsvToJSON(value?: Csv | null): any {
  if (value == null) {
    return value;
  }
  return {
    author_id: value['authorId'],
    author_key: value['authorKey'],
    columns: value['columns'],
    company_id: value['companyId'],
    csv_id: value['csvId'],
    custom_mapping: value['customMapping'],
    date_created: value['dateCreated'],
    date_created_iso: value['dateCreatedIso'],
    date_modified: value['dateModified'],
    date_modified_iso: value['dateModifiedIso'],
    download_url: value['downloadUrl'],
    filename: value['filename'],
    gcs_filename: value['gcsFilename'],
    id: value['id'],
    import_results: ImportResultsToJSON(value['importResults']),
    key: value['key'],
    labels: value['labels'],
    lead_mapping: value['leadMapping'],
    name: value['name'],
    num_rows: value['numRows'],
    sort_name: value['sortName'],
    state: value['state'],
    strategy: value['strategy'],
    tags: value['tags'],
  };
}
